import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enumeratorClient, recruiterClient } from "config/axios";
import PATHS from "config/paths";
import { QueryKeys } from "config/query-keys";
import { RoleTypes } from "enum/role-type-enum";
import { SocialMediumTypes } from "enum/social-medium";
import { storage } from "utils/storage";

type ParamsType = {
  roleType: string | null;
  medium: string | null;
};

export const transferOauthSession = (params: ParamsType): Promise<{}> => {
  if (params.roleType === RoleTypes.ENUMERATOR) {
    const mediumUrl =
      params.medium === SocialMediumTypes.FACEBOOK
        ? PATHS.enumerator.oauthFacebokleLogin
        : PATHS.enumerator.oauthGoogleLogin;

    return enumeratorClient.httpClient.post(mediumUrl, {}, { withCredentials: true });
  } else {
    const mediumUrl =
      params.medium === SocialMediumTypes.FACEBOOK
        ? PATHS.recruiter.oauthFacebokleLogin
        : PATHS.recruiter.oauthGoogleLogin;

    return recruiterClient.httpClient.post(mediumUrl, {}, { withCredentials: true });
  }
};

export const useOauthSession = (params: ParamsType) => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async ({ data, token }: any, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.ENUMERATOR] });

      const userInfo = {
        userName: data?.userName,
        email: data?.email,
        role: data?.role?.roleTitle,
        _id: data?._id,
        country: data?.country,
      };

      storage.setUserInStorage(userInfo);
      storage.setTokenInStorage(token);
    },

    mutationFn: () => transferOauthSession(params),
  });
};
